import React from 'react';
import { Button } from '../ui/button';
import { Moon, RotateCcw } from 'lucide-react';

export const BedtimeToggle = ({ bedtimeMode, onEnable, onDisable, es = false }) => (
  <div className="flex flex-wrap items-center justify-between gap-2">
    <Button
      variant={bedtimeMode ? 'default' : 'outline'}
      size="sm"
      onClick={bedtimeMode ? onDisable : onEnable}
      data-testid="bedtime-mode-btn"
      className={
        bedtimeMode
          ? 'bg-indigo-900 hover:bg-indigo-950 text-white border-0'
          : 'border-indigo-300 text-indigo-700 hover:bg-indigo-50 dark:border-indigo-700 dark:text-indigo-300 dark:hover:bg-indigo-900/30'
      }
    >
      <Moon className="w-4 h-4 mr-2" />
      {bedtimeMode ? (es ? 'Modo noche activado' : 'Bedtime on') : (es ? 'Modo noche' : 'Bedtime mode')}
    </Button>
    {bedtimeMode && (
      <span className="text-xs text-muted-foreground italic">
        {es ? 'Escena nocturna • 0.85× • el volumen baja en 20 min' : 'Night scene • 0.85× • volume fades over 20 min'}
      </span>
    )}
  </div>
);

export const ResumeBanner = ({ bookmark, onResume, onDismiss, es = false }) => (
  <div
    className="flex items-center justify-between gap-3 p-3 rounded-lg bg-indigo-50 dark:bg-indigo-950/40 border border-indigo-200 dark:border-indigo-800"
    data-testid="bedtime-resume-banner"
  >
    <div className="flex items-start gap-2 min-w-0">
      <RotateCcw className="w-4 h-4 mt-0.5 text-indigo-600 dark:text-indigo-300 shrink-0" />
      <div className="min-w-0">
        <p className="text-sm font-medium text-indigo-900 dark:text-indigo-100 truncate">
          {es ? 'Reanudar donde te dormiste' : 'Resume where you fell asleep'}
        </p>
        <p className="text-xs text-indigo-700 dark:text-indigo-300 truncate">
          {bookmark.verse_reference}
        </p>
      </div>
    </div>
    <div className="flex gap-2 shrink-0">
      <Button size="sm" onClick={onResume} data-testid="bedtime-resume-btn">
        {es ? 'Reanudar' : 'Resume'}
      </Button>
      <Button size="sm" variant="ghost" onClick={onDismiss} data-testid="bedtime-resume-dismiss-btn">
        {es ? 'Descartar' : 'Dismiss'}
      </Button>
    </div>
  </div>
);
